import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var swiper = new Swiper(".swiper", {
    slidesPerView: 5,
    spaceBetween: '3.64%',
    loop:true,
    speed:1000,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
    breakpoints: {
      1366: {  //当屏幕宽度小于等于1280
        slidesPerView: 5,
        spaceBetween: '3.64%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 4,
        spaceBetween: '3.64%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        spaceBetween: '3.64%',
      }
    } 
});